export const PRO_FORMA_DESCRIPTION_MAX_LENGTH = 250;

export const DESCRIPTION_LENGTH_EXCEEDED_MSG = `Description cannot exceed ${PRO_FORMA_DESCRIPTION_MAX_LENGTH} characters`;
